import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnfoldMore = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-224.00 -348.44 1600.00 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1065 649 599 183Q589 173 576.0 173.0Q563 173 553 183L87 649Q77 659 77.0 672.0Q77 685 87 695L137 745Q147 755 160.0 755.0Q173 755 183 745L576 352L969 745Q979 755 992.0 755.0Q1005 755 1015 745L1065 695Q1075 685 1075.0 672.0Q1075 659 1065 649ZM1065 1033 599 567Q589 557 576.0 557.0Q563 557 553 567L87 1033Q77 1043 77.0 1056.0Q77 1069 87 1079L137 1129Q147 1139 160.0 1139.0Q173 1139 183 1129L576 736L969 1129Q979 1139 992.0 1139.0Q1005 1139 1015 1129L1065 1079Q1075 1069 1075.0 1056.0Q1075 1043 1065 1033Z"
	})
});
export default SvgUnfoldMore;
